module.exports = __webpack_public_path__ + "img/68.b9e558a5.jpg";